import React from "react";

import styles from "./Input.module.scss";
import { Image } from "@src/components/Image";

const Input = ({ icon, ...inputProps }) => {
  return (
    <div className={styles.inputContainer}>
      {icon && (
        <div className={styles.inputContainer__icon}>
          {/*<Image src={`/api/proxyimage?url=${encodeURIComponent(icon)}`} alt="inputIcon" width={18} height={18} />*/}
          <img src={icon} alt="inputIcon" width="18px" height="18px" />
        </div>
      )}
      <input
        {...inputProps}
        {...(inputProps?.type === "number"
          ? {
              onKeyDown: (e) => {
                if (
                  e.key === "-" ||
                  e.key === "e" ||
                  e.key === "E" ||
                  e.key === "+"
                )
                  e.preventDefault();
              },
            }
          : {})}
      />
    </div>
  );
};

export default Input;
